var map = {
	"./images/add-one.png": 1503,
	"./images/add-two.png": 1504,
	"./images/amulet-normal.png": 1505,
	"./images/amulet-rare.png": 1506,
	"./images/amulet_01.png": 1507,
	"./images/amulet_02.png": 1508,
	"./images/amulet_03.png": 1509,
	"./images/amulet_04.png": 1510,
	"./images/amulet_05.png": 1511,
	"./images/amulet_06.png": 1512,
	"./images/amulet_07.png": 1513,
	"./images/amulet_08.png": 1514,
	"./images/amulet_09.png": 1515,
	"./images/amulet_10.png": 1516,
	"./images/amulet_11.png": 1517,
	"./images/amulet_12.png": 1518,
	"./images/background.jpg": 1519,
	"./images/background_.png": 1520,
	"./images/dice-1.png": 1521,
	"./images/dice-2.png": 1522,
	"./images/dice-3.png": 1523,
	"./images/dice-4.png": 1524,
	"./images/dice-5.png": 1525,
	"./images/dice-6.png": 1526,
	"./images/dice.png": 1527,
	"./images/home.png": 1528,
	"./images/play-bg.png": 1529,
	"./images/torch-full.png": 1530,
	"./images/torch-on.png": 1531,
	"./images/walk-point.png": 1532,
	"./images/yardnapa-bg.png": 1533,
	"./images/yardnapha-runout.png": 1534
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1502;